import { motion } from "framer-motion";

const LABELS = {
  all: "All",
  peace: "Peace",
  anxiety: "Anxiety",
  faith: "Faith",
  hope: "Hope",
  love: "Love",
  strength: "Strength",
  gratitude: "Gratitude",
  joy: "Joy",
  guidance: "Guidance",
  forgiveness: "Forgiveness",
};

export const CategoryChips = ({ categories, active, onSelect }) => {
  const list = ["all", ...categories];
  return (
    <div
      className="w-full overflow-x-auto no-scrollbar"
      data-testid="category-chips"
    >
      <div className="flex gap-2 px-6 py-3 min-w-max">
        {list.map((cat) => {
          const isActive = active === cat;
          return (
            <motion.button
              key={cat}
              onClick={(e) => {
                e.stopPropagation();
                onSelect(cat);
              }}
              whileTap={{ scale: 0.94 }}
              data-testid={`chip-${cat}`}
              className={[
                "font-ui rounded-full px-4 py-1.5 text-[11px] md:text-xs uppercase tracking-[0.14em] transition-colors duration-300 border",
                isActive
                  ? "bg-[#4A5D4E] text-[#F5F3ED] border-[#4A5D4E]"
                  : "bg-[#F5F3ED]/70 backdrop-blur-sm text-[#6A6661] border-[#E5E1D8] hover:bg-[#EAE6DF]",
              ].join(" ")}
            >
              {LABELS[cat] || cat}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
